import { render } from "./EadgeContainer.vue?vue&type=template&id=34988f60"
import script from "./EadgeContainer.vue?vue&type=script&lang=js"
export * from "./EadgeContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"EadgeContainer.vue"]])

export default __exports__